import NovuTabList from './novu-tab-list';

export default NovuTabList;
